<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide"  transition-show="scale">
    <q-card
      class="q-dialog-plugin p-24 min-h-[350px] grid place-items-center text-alert-success"
    >
      <div v-if="type === 'sucess'" class="flex flex-col">
        <Vue3Lottie
          class="!w-[200px]"
          :loop="false"
          :speed="0.75"
          :animation-data="sucess"
        />
        <p class="text-paragraph-1 !font-semibold text-center mt-16">
          {{ text }}
        </p>
      </div>
      <div
        v-if="timeout"
        class="timeout-bar"
        :style="{
          width: barWidth + '%',
          transition: 'width 100ms linear',
        }"
      ></div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useDialogPluginComponent } from 'quasar'
import { Vue3Lottie } from 'vue3-lottie'
import sucess from 'src/assets/lottie/sucess.json'

const props = defineProps({
  type: String,
  text: String,
  timeout: {
    type: Number,
    default: 3000,
  },
})

defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } =
  useDialogPluginComponent()

const barWidth = ref(100)
let interval = null
let startTime = null

const startTimeout = () => {
  if (!props.timeout) return
  startTime = Date.now()
  interval = setInterval(() => {
    const elapsed = Date.now() - startTime
    barWidth.value = Math.max(
      0,
      100 - (elapsed / props.timeout) * 100
    )
    if (elapsed >= props.timeout) {
      clearInterval(interval)
      onDialogHide()
    }
  }, 100)
}

onMounted(startTimeout)
onBeforeUnmount(() => clearInterval(interval))

watch(
  () => props.timeout,
  () => {
    clearInterval(interval)
    barWidth.value = 100
    startTimeout()
  }
)
</script>

<style scoped>
.timeout-bar {
  height: 6px;
  background: currentColor;
  position: absolute;
  left: 0;
  bottom: 0;
}
</style>
